module.exports = __webpack_public_path__ + "img/item-art1.511a35a5.svg";